"use client";

import { c as _c } from "react/compiler-runtime";
import { forwardRef, ReactNode, ComponentRef, ComponentPropsWithoutRef } from "react";
import { Trigger, Provider, Root, Content } from "@radix-ui/react-tooltip";
import { FiArrowUpRight } from "react-icons/fi";
import { cn } from "@/utils";
const ToolTip = ({
  content,
  children = <FiArrowUpRight className="text-3xl text-primary group-hover:text-mint" />
}: {
  content: string;
  children?: ReactNode;
}) => {
  const lines = content.split("\\");
  return <TooltipProvider delayDuration={100}>
      <Tooltip>
        <Trigger title={content} asChild>
          {children}
        </Trigger>
        <TooltipContent>
          {lines.map(line => <p key={"line-" + line}>{line}</p>)}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>;
};
const TooltipProvider = Provider;
const Tooltip = Root;
const TooltipTrigger = Trigger;
const TooltipContent = forwardRef<ComponentRef<typeof Content>, ComponentPropsWithoutRef<typeof Content>>((t0, ref) => {
  const $ = _c(11);
  let className;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      sideOffset: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = t1;
  } else {
    className = $[1];
    props = $[2];
    t1 = $[3];
  }
  const sideOffset = t1 === undefined ? 8 : t1;
  let t2;
  if ($[4] !== className) {
    t2 = cn("z-50 overflow-hidden rounded-full border bg-dark px-3 py-1.5 text-center text-sm text-white animate-in fade-in-0 zoom-in-95", "data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2", className);
    $[4] = className;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== props || $[7] !== ref || $[8] !== sideOffset || $[9] !== t2) {
    t3 = <Content ref={ref} sideOffset={sideOffset} className={t2} {...props} />;
    $[6] = props;
    $[7] = ref;
    $[8] = sideOffset;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
});
TooltipContent.displayName = Content.displayName;
export default ToolTip;
export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider };